import { useUser } from '../../../api/queries/use-user';

/**
 * Coerces draft/load preferences to be true when not explicitly set.
 * Do not use these values to update user preferences, only for reading/displaying purposes. 
 */
export const useDraftLoadPreferences = () => {
    const { user } = useUser();

    return {
        draftsLoadsDefaultSort: user.preferences.draftsLoadsDefaultSort ?? false,
        showLoadDate: user.preferences.showLoadDate ?? true,
        estimatedTotalTripMode: user.preferences.estimatedTotalTripMode ?? 'time',
        showTractor: user.preferences.showTractor ?? true,
        showTrailer: user.preferences.showTrailer ?? true,
    };
}